module.exports = __webpack_public_path__ + "static/media/logout.4373aae2.svg";